/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_TitleInputs */

const en_builder_plan_title = /** @type {(inputs: Builder_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder — Build it for me`)
};

const id_builder_plan_title = /** @type {(inputs: Builder_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder — Bangunkan untuk saya`)
};

/**
* | output |
* | --- |
* | "Builder — Build it for me" |
*
* @param {Builder_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_title = /** @type {((inputs?: Builder_Plan_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_title(inputs)
	return en_builder_plan_title(inputs)
});